module.exports = __webpack_public_path__ + "img/eth_kintsugi.09b956a5.svg";